export default function isSafari () {
  const userAgent = navigator.userAgent
  const isSafari = userAgent.includes('Safari') && !userAgent.includes('Chrome')

  // some user agents dont have safari in user agent string but are being called from
  // iphone webview. So, we need to handle that case as well
  if (
    !userAgent.includes('Safari') &&
        !userAgent.includes('Chrome') &&
        !userAgent.includes('Firefox') &&
        userAgent.toLowerCase().includes('iphone')
  ) {
    return true
  }

  // Handling user agent strings like
  // Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36
  if (
    isSafari &&
        (
          userAgent.toLowerCase().includes('windows') ||
            userAgent.toLowerCase().includes('linux')
        )
  ) {
    return false
  }

  return isSafari
}
